import {useState, useCallback, useEffect} from 'react';
import {Routes, Route} from 'react-router-dom';
// import { getAnalytics } from "firebase/analytics";

//Frontend
import Home from "./frontend/pages/Home";
import Servizi from "./frontend/pages/Servizi";
import ChiSiamo from "./frontend/pages/ChiSiamo";
import Contatti from "./frontend/pages/Contatti";


//404
import NotFound from "./frontend/pages/NotFound";

import {BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XS, LAYOUT_LG, LAYOUT_MD, LAYOUT_SM, LAYOUT_XS } from './config';


const App = () => {
  const [resizeListener, setResizeListener] = useState(false);
  const [layout, setLayout] = useState(null);


  const handleResize = useCallback(() => {
    setLayout(window.innerWidth <= BREAKPOINT_XS ? LAYOUT_XS : (window.innerWidth <= BREAKPOINT_SM ? LAYOUT_SM : (window.innerWidth <= BREAKPOINT_MD ? LAYOUT_MD : LAYOUT_LG)));
  }, []);

  useEffect(() => {
    if(!resizeListener){
      setResizeListener(true);
      window.addEventListener("resize", handleResize, false);
      handleResize();
    }
  }, [handleResize, resizeListener]);

  return (
    <Routes>

      {/*Frontend*/}
      <Route exact path='/' element={<Home layout={layout} />} />
      <Route exact path='/servizi' element={<Servizi layout={layout} />} />
      <Route exact path='/chi-siamo' element={<ChiSiamo layout={layout} />} />
      <Route exact path='/contatti' element={<Contatti layout={layout} />} />

      {/*404*/}
      <Route path='*' element={<NotFound layout={layout} />} />
    </Routes>
  );
}

export default App;
